function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import omit from 'object.omit';
import { format as formatDate, isAfter } from 'date-fns';
import { VRangeMonthYearDecadePicker as RangeMonthYearDecadePicker } from '@cloud-sn/v-datepicker';
import localeCN from '../locale/zh_CN';
import Icon from '../../icon';
export default {
  model: {
    prop: 'selectedValue'
  },
  props: _objectSpread({}, omit(RangeMonthYearDecadePicker.props, ['mode', 'disabledMonth', 'disabledYear']), {
    prefixCls: {
      type: String,
      default: 'ux-calendar'
    },
    locale: {
      type: Object,
      default: function _default() {
        return localeCN.lang;
      }
    },
    placeholder: {
      type: [String, Array],
      default: ''
    },
    selectedValue: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(val) {
        return val.every(function (v) {
          return v instanceof Date;
        });
      }
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(value) {
        return ['small', 'large', 'default'].indexOf(value) > -1;
      }
    },
    allowClear: {
      type: Boolean,
      default: true
    }
  }),
  data: function data() {
    return {
      innerValue: null
    };
  },
  computed: {
    dateFormat: function dateFormat() {
      var format = this.format;
      return format || 'YYYY-MM';
    },
    pickerClasses: function pickerClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          theme = this.theme,
          size = this.size;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-picker"), true), _defineProperty(_ref, "".concat(prefixCls, "-picker-").concat(theme), true), _defineProperty(_ref, "".concat(prefixCls, "-picker-").concat(size), true), _ref;
    },
    pickerInputClass: function pickerInputClass() {
      var _ref2;

      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          size = this.size;
      var inputPrefix = 'ux-input';
      var map = {
        small: 'sm',
        large: 'lg'
      };
      return _ref2 = {}, _defineProperty(_ref2, inputPrefix, true), _defineProperty(_ref2, "".concat(prefixCls, "-picker-input"), true), _defineProperty(_ref2, "".concat(inputPrefix, "-disabled"), disabled), _defineProperty(_ref2, "".concat(inputPrefix, "-").concat(map[size]), size !== 'default'), _ref2;
    },
    normalizeLocale: function normalizeLocale() {
      var locale = this.locale;

      if (!locale) {
        return localeCN.lang;
      }

      return locale.lang ? locale.lang : locale;
    },
    startPlaceholder: function startPlaceholder() {
      var placeholder = this.placeholder,
          normalizeLocale = this.normalizeLocale,
          mode = this.mode;

      var _mode = _slicedToArray(mode, 1),
          startMode = _mode[0];

      var rangeMonthPlaceholder = normalizeLocale.rangeMonthPlaceholder,
          rangeYearPlaceholder = normalizeLocale.rangeYearPlaceholder;
      var holder = (startMode === 'month' ? rangeMonthPlaceholder : rangeYearPlaceholder)[0];

      if (placeholder) {
        if (Array.isArray(placeholder)) {
          if (placeholder.length > 0) {
            var _placeholder = _slicedToArray(placeholder, 1);

            holder = _placeholder[0];
          }
        } else {
          holder = placeholder;
        }
      }

      return holder;
    },
    endPlaceholder: function endPlaceholder() {
      var placeholder = this.placeholder,
          normalizeLocale = this.normalizeLocale,
          mode = this.mode;

      var _mode2 = _slicedToArray(mode, 2),
          endMode = _mode2[1];

      var rangeMonthPlaceholder = normalizeLocale.rangeMonthPlaceholder,
          rangeYearPlaceholder = normalizeLocale.rangeYearPlaceholder;
      var holder = (endMode === 'month' ? rangeMonthPlaceholder : rangeYearPlaceholder)[1];

      if (placeholder) {
        if (Array.isArray(placeholder)) {
          if (placeholder.length > 1) {
            var _placeholder2 = _slicedToArray(placeholder, 2);

            holder = _placeholder2[1];
          } else if (placeholder.length > 0) {
            var _placeholder3 = _slicedToArray(placeholder, 1);

            holder = _placeholder3[0];
          }
        } else {
          holder = placeholder;
        }
      }

      return holder;
    },
    isCanClear: function isCanClear() {
      var disabled = this.disabled,
          allowClear = this.allowClear,
          innerValue = this.innerValue;

      var _innerValue = _slicedToArray(innerValue, 2),
          start = _innerValue[0],
          end = _innerValue[1];

      return !disabled && allowClear && (start || end);
    },
    startValue: function startValue() {
      var innerValue = this.innerValue,
          dateFormat = this.dateFormat;

      var _innerValue2 = _slicedToArray(innerValue, 1),
          start = _innerValue2[0];

      return start ? formatDate(start, dateFormat) : '';
    },
    endValue: function endValue() {
      var innerValue = this.innerValue,
          dateFormat = this.dateFormat;

      var _innerValue3 = _slicedToArray(innerValue, 2),
          end = _innerValue3[1];

      return end ? formatDate(end, dateFormat) : '';
    }
  },
  watch: {
    selectedValue: function selectedValue(nVal) {
      this.setInnerValue(nVal, false);
    }
  },
  created: function created() {
    var selectedValue = this.selectedValue,
        setInnerValue = this.setInnerValue;
    setInnerValue(selectedValue, false);
  },
  methods: {
    setInnerValue: function setInnerValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var formatStrs = arguments.length > 2 ? arguments[2] : undefined;
      var val = value || [];

      if (val.length === 2) {
        var _val = val,
            _val2 = _slicedToArray(_val, 2),
            start = _val2[0],
            end = _val2[1];

        if (isAfter(start, end)) {
          val = [end, start];
        }
      }

      this.innerValue = val;

      if (trigger) {
        this.$emit('input', val);
        this.$emit('change', val, formatStrs);
      }
    },
    onChange: function onChange(value, formatStrs) {
      this.setInnerValue(value, true, formatStrs);
    },
    onClearClick: function onClearClick(e) {
      e.stopPropagation();
      e.preventDefault();
      this.setInnerValue([]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $props = this.$props,
        $listeners = this.$listeners,
        prefixCls = this.prefixCls,
        pickerClasses = this.pickerClasses,
        pickerInputClass = this.pickerInputClass,
        innerValue = this.innerValue,
        startValue = this.startValue,
        endValue = this.endValue,
        disabled = this.disabled,
        dateFormat = this.dateFormat,
        startPlaceholder = this.startPlaceholder,
        endPlaceholder = this.endPlaceholder,
        isCanClear = this.isCanClear,
        onChange = this.onChange,
        onClearClick = this.onClearClick;

    var props = _objectSpread({}, omit($props, ['format']), {
      selectedValue: innerValue,
      pickerPrefixCls: "".concat(prefixCls, "-picker-container"),
      format: dateFormat
    });

    var on = _objectSpread({}, omit($listeners, ['input', 'change']), {
      change: onChange
    });

    return h(RangeMonthYearDecadePicker, {
      "props": _objectSpread({}, props),
      "on": _objectSpread({}, on)
    }, [h("template", {
      "slot": "trigger"
    }, [h("div", {
      "class": pickerClasses
    }, [h("div", {
      "class": pickerInputClass
    }, [h("input", {
      "class": "".concat(prefixCls, "-range-picker-input"),
      "domProps": {
        "value": startValue
      },
      "attrs": {
        "placeholder": startPlaceholder,
        "disabled": disabled,
        "type": "text",
        "readonly": true,
        "tabindex": "-1"
      }
    }), h("span", {
      "class": "".concat(prefixCls, "-range-picker-separator")
    }, [" ~ "]), h("input", {
      "class": "".concat(prefixCls, "-range-picker-input"),
      "domProps": {
        "value": endValue
      },
      "attrs": {
        "placeholder": endPlaceholder,
        "disabled": disabled,
        "type": "text",
        "readonly": true,
        "tabindex": "-1"
      }
    }), isCanClear ? h(Icon, {
      "class": "".concat(prefixCls, "-picker-clear"),
      "attrs": {
        "type": "close_circle"
      },
      "on": {
        "click": onClearClick
      }
    }) : null, h("span", {
      "class": "".concat(prefixCls, "-picker-icon")
    })])])])]);
  }
};